import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Login from './pages/Login';
import Register from './pages/Register';
import CreatorRegister from './pages/CreatorRegister';
import Home from './pages/Home';
import EditProfile from './pages/EditProfile';
import EditUsername from './pages/EditUsername';
import EditEmail from './pages/EditEmail';
import EditPhone from './pages/EditPhone';
import Bankaccountdetails from './pages/Bankaccountdetails';
import Walletaddress from './pages/Walletaddress';
import ChangePassword from './pages/ChangePassword';
import PrivacySafetySettings from './pages/PrivacySafetySettings';
import NotificationSettings from './pages/NotificationSettings';
import EmailNotificationSettings from './pages/EmailNotificationSettings';
import SiteNotificationSettings from './pages/SiteNotificationSettings';
import SocialAccountSettings from './pages/SocialAccountSettings';
import DeleteAccount from './pages/DeleteAccount';
import AccountSettings from './pages/AccountSettings';
import MyProfile from './pages/MyProfile';
import Collections from './pages/Collections';
import UserProfile from './pages/UserProfile';
import Notifications from './pages/Notifications';
import Contact from './pages/Contact';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import CookieNotice from './pages/CookieNotice';
import DMCA from './pages/DMCA';
import USC from './pages/USC';
import Contract from './pages/Contract';
import TransparencyCenter from './pages/TransparencyCenter';
import TransparencyCenterSingle from './pages/TransparencyCenterSingle';
import AntiSlavery from './pages/AntiSlavery';
import PaymentOptions from './pages/PaymentOptions';
import About from './pages/About';
import Help from './pages/Help';
import Fans from './pages/Fans';
import SubscriptionSettings from './pages/SubscriptionSettings';
import CreatePost from './pages/CreatePost';
import SinglePost from './pages/SinglePost';
import Chat from './pages/Chat';
import ChatSend from './pages/ChatSend';
import ChatMessage from './pages/ChatMessage';
import ChatGallery from './pages/ChatGallery';
import UserList from './pages/UserList'; 
import Restricted from './pages/Restricted'; 
import Blocked from './pages/Blocked';
import LoginSessions from './pages/LoginSessions';
import TwoStep from './pages/TwoStep';
import HelpContentPage from './pages/HelpContentPage';
import ResetPassword from './pages/ResetPassword';
// Add LinkedAccounts import
import GoogleAccounts from './pages/GoogleAccounts';
import FacebookAccounts from './pages/FacebookAccounts';
import XAccounts from './pages/XAccounts';

const NormalizeURL = () => {
  const location = useLocation();
  
  useEffect(() => {
    if (location.pathname !== location.pathname.toLowerCase()) {
      // Redirect to lowercase version of URL
      window.location.replace(location.pathname.toLowerCase());
    }
  }, [location]);

  return null;
};

const App = () => {
  return (
    <Router>
      <NormalizeURL />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/creator-register" element={<CreatorRegister />} />
        <Route path="/home" element={<Home />} />
        <Route path="/create-post" element={<CreatePost />} />
        <Route path="/editprofile" element={<EditProfile />} />
        <Route path="/editusername" element={<EditUsername />} />
        <Route path="/editemail" element={<EditEmail />} />
        <Route path="/editphone" element={<EditPhone />} />
        <Route path="/bankaccountdetails" element={<Bankaccountdetails />} />
        <Route path="/walletaddress" element={<Walletaddress />} />
        <Route path="/changepassword" element={<ChangePassword />} />
        <Route path="/privacysafetysettings" element={<PrivacySafetySettings />} />
        <Route path="/notificationsettings" element={<NotificationSettings />} />
        <Route path="/emailnotificationsettings" element={<EmailNotificationSettings />} />
        <Route path="/sitenotificationsettings" element={<SiteNotificationSettings />} />
        <Route path="/socialaccountsettings" element={<SocialAccountSettings />} />
        <Route path="/deleteaccount" element={<DeleteAccount />} />
        <Route path="/accountsettings" element={<AccountSettings />} />
        <Route path="/loginsessions" element={<LoginSessions />} />
        <Route path="/2fa" element={<TwoStep />} />
        <Route path="/myprofile" element={<MyProfile />} />
        <Route path="/collections" element={<Collections />} />
        <Route path="/:user_name" element={<UserProfile />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/cookie-notice" element={<CookieNotice />} />
        <Route path="/dmca" element={<DMCA />} />
        <Route path="/usc" element={<USC />} />
        <Route path="/contract" element={<Contract />} />
        <Route path="/transparency-center" element={<TransparencyCenter />} />
        <Route path="/transparency-center/:id" element={<TransparencyCenterSingle />} />
        <Route path="/anti-slavery" element={<AntiSlavery />} />
        <Route path="/payment-options" element={<PaymentOptions />} />
        <Route path="/about" element={<About />} />
        <Route path="/help" element={<Help />} />
        <Route path="/fans" element={<Fans />} />
        <Route path="/blocked" element={<Blocked />} />
        <Route path="/restricted" element={<Restricted />} />
        <Route path="/subscription-settings" element={<SubscriptionSettings />} />
        <Route path="/:post_id/:username" element={<SinglePost />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/chatsend" element={<ChatSend />} />  
        <Route path="/chatmessage/:user_id" element={<ChatMessage />} />
        <Route path="/chatmessage/:user_id/gallery" element={<ChatGallery />} />
        <Route path="/user-list/:id/:slug" element={<UserList />} />    
        <Route path="/help/:mainCategoryId/:parentCategoryId/:childCategoryId" element={<HelpContentPage />} />
        <Route path="/resetpassword" element={<ResetPassword />} /> 
        {/* Add LinkedAccounts route */}
        <Route path="/google-accounts" element={<GoogleAccounts />} /> 
        <Route path="/facebook-accounts" element={<FacebookAccounts />} /> 
        <Route path="/x-accounts" element={<XAccounts />} /> 
      </Routes>
    </Router>
  );
};

export default App;
